import React from "react";
import { styled } from "@mui/material/styles";
import TextareaAutosize from "@mui/material/TextareaAutosize";

const StyledTextarea = styled(TextareaAutosize)(({ theme }) => ({
    width: "100%",
    padding: "8px",
    fontSize: theme.typography.customFontSize[2],
    fontWeight: theme.typography.customFontWeight[1],
    borderRadius: "8px",
    border: `1px solid ${theme.palette.primary.greyFifth}`,
    outline: "none",
    color: theme.palette.primary.greyPrimary,

    "&:hover": {
        borderColor: theme.palette.primary.mainHover,
    },

    "&:focus": {
        borderColor: theme.palette.primary.greyPrimary,
    },

    "&::placeholder": {
        height: '19px',
        fontSize: theme.typography.customFontSize[2],
        color: theme.palette.primary.greyThird,
        fontWeight: theme.typography.customFontWeight[3],
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        fontFamily: "Open Sans",
    },
}));

const TextAreaField = ({
    value,
    onChange,
    placeholder = "",
    rows = 3,
    disabled = false,
}) => {
    return (
        <StyledTextarea
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            minRows={rows}
            disabled={disabled}
        />
    );
};

export default TextAreaField;
